import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const WhiteCross = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <Path
      fill="#FDFBF9"
      d="m6.446 18.215-.646-.661L11.338 12 5.8 6.446l.646-.661L12 11.338l5.554-5.553.646.661L12.66 12l5.539 5.554-.646.662L12 12.661l-5.554 5.553Z"
    />
  </Svg>
)
export default WhiteCross
